import type { YachtDieValue, YachtTurnRngState } from "../types";

const UINT32_SIZE = 4_294_967_296;
const MULBERRY_INCREMENT = 0x6d2b79f5;

function hashSeed(seed: string): number {
  let hash = 2_166_136_261;
  for (const char of seed) {
    hash ^= char.charCodeAt(0);
    hash = Math.imul(hash, 16_777_619);
  }
  return hash >>> 0;
}

export function normalizeSeed(seed: string): string {
  const normalized = seed.trim();
  if (normalized.length === 0) {
    throw new Error("Seed is required");
  }
  return normalized;
}

export function createTurnRngState(
  gameSeed: string,
  playerId: string,
  sheetRound: number,
): YachtTurnRngState {
  const streamId = `${normalizeSeed(gameSeed)}:${playerId}:${sheetRound}`;
  return {
    algorithm: "mulberry32",
    streamId,
    state: hashSeed(streamId),
  };
}

export function nextRandom(rngState: YachtTurnRngState): {
  readonly rngState: YachtTurnRngState;
  readonly value: number;
} {
  const nextState = (rngState.state + MULBERRY_INCREMENT) >>> 0;
  let value = nextState;
  value = Math.imul(value ^ (value >>> 15), value | 1);
  value ^= value + Math.imul(value ^ (value >>> 7), value | 61);

  return {
    rngState: {
      ...rngState,
      state: nextState,
    },
    value: ((value ^ (value >>> 14)) >>> 0) / UINT32_SIZE,
  };
}

export function rollDie(rngState: YachtTurnRngState): {
  readonly rngState: YachtTurnRngState;
  readonly value: YachtDieValue;
} {
  const result = nextRandom(rngState);
  return {
    rngState: result.rngState,
    value: (Math.floor(result.value * 6) + 1) as YachtDieValue,
  };
}
